export default __webpack_public_path__ + "static/media/sports.5114b725.png";